import VSCanvas from './vsweb-canvas'
import { Command, CommandInstance } from './vsweb-command'
import { EventEmitter } from 'events'
import XMLParser = require('./DOMXMLParser')
import Stats from './stats'
import * as $ from 'jquery'

let parseXML = XMLParser.parseXML

declare var _AlternateLicenseErrorHandling: number;

declare function escape(any): any;
export type WebSocketAddress = string;
let wsUrl: WebSocketAddress;
const WithTypeParameters = {
    GetTemplate: true
}


var CODEC_STATUS = {
    Unknown: 0,
    JPG: 1,
    HQJPG: 2,
    H264: 3,
    PNG: 4,

    toString: function (index) {
        return Object.keys(this)[index];
    }
};

var MESSAGE_TYPE = {
    Unknown: 0,
    Request: 1,
    Response: 2,
    Push: 3,

    toString: function (index) {
        return Object.keys(this)[index];
    }
};

var PAYLOAD_TYPE_BINARY = {
    Unknown: 0,

    // Out
    XMLCall: 1,
    XMLCallNoMirror: 2,
    ServerCommand: 3,
    InstanceCommand: 4,
    AuthenticateSession: 5,

    // Backendcommands
    CloseSession: 6,
    RemoveToken: 7,
    TransferClient: 8,
    ListClients: 9,
    LoadWhitelist: 10,
    ClearWhitelist: 11,

    // In
    XMLResponse: 50,
    ServerResponse: 51,
    InstanceResponse: 52,
    XMLEvent: 53,
    Image: 54,
    Tree: 55,
    GeneralResponse: 56,
    AuthenticationRequired: 57,
    SessionInfo: 58,

    // Special payloads

    Ping: 100,
    Pong: 101,
    TerminateClient: 103,

    // FileExplorer

    GetFolderContent: 210,
    GetFolderFileCount: 211,
    SearchByString: 212,
    CreateFolder: 213,

};

var PAYLOAD_TYPE_TEXT = {
    Unknown: 0,

    // OUT
    XMLCall: 1,
    XMLCallNoMirror: 2,
    ServerCommand: 3,
    InstanceCommand: 4,
    AuthenticateSession: 5,
    CloseSession: 6,
    RemoveToken: 7,

    // IN
    XMLResponse: 8,
    ServerResponse: 9,
    InstanceResponse: 10,
    XMLEvent: 11,
    Image: 12,
    Tree: 13,
    GeneralResponse: 14,
    toString: function (index) {
        return Object.keys(this)[index];
    }
};

function convertBigEndianUInt64ToNumber(eightBytes: Uint8Array): number {
    let uint64: number = 0
    for (var i = 0; i < eightBytes.length; i++) {
        uint64 += eightBytes[i] * Math.pow(256, i)
    }
    return uint64
}

function convertNumberToBigEndianUInt64(num): Uint8Array {
    var eightBytes = new Uint8Array(8)
    var array = []
    var remainder = num
    do {
        remainder = num % 256
        array.push(remainder)
        num = (num - remainder) / 256
    } while (num > 0)

    for (var i = 0; i < array.length; i++) {
        eightBytes[i] = array[i]
    }

    return eightBytes
}

export const logMsg = "== VSWebclient ==: "

export type CanvasMode = 'streaming' | 'image';

export interface Options {
    canvasMode?: CanvasMode,
    parseXMLResponse?: boolean,
    emitXMLResponsesUnparsed?: boolean,
    sendSessionReady?: boolean,
    skipVSLogo?: boolean,
    blockOnLoad?: boolean,
    sessionToConnect?: string,
    client?: string,
    testForSessions?: boolean,
    preventRetry?: boolean,
    routeOnRetriedAuthenticationFail?: boolean
    spectatorMode?: boolean,
    alwaysParkSessions?: boolean,
    freezeParkTime?: number,
    disableFreezeParking?: boolean,
    autoConnectToParkedSession?: boolean
}

export interface SessionInfo {
    socket: WebSocket
    commandTimer: number
    canvasMode: CanvasMode
    compressionLQ: number
    compressionHQ: number
    canvasWidth: number
    canvasHeight: number
    firstImageRecieved: boolean
    token: string
}

export interface Pos2D {
    x: number;
    y: number;
}

export interface ConfigurationViewsData {
    Image: string
    Name: string
    Position: string
}


export interface ConfigurationViewChangedEvent {
    pos: number,
    view: ConfigurationViewsData
}
/**
 * VSWebClient: responsible for rendering and communicating with ViweStation WebViewer server
 */

export class VSWebClient extends EventEmitter {

    // static VSWebClient = VSWebClient

    sessionInfo: SessionInfo = {
        socket: undefined,
        commandTimer: 0,
        canvasMode: 'image',
        compressionLQ: 50,
        compressionHQ: 95,
        canvasWidth: 0,
        canvasHeight: 0,
        firstImageRecieved: false,
        token: ''
    };

    session: string;
    sessionFromStorage: boolean = false;
    sessionTerminated: boolean = false;
    isOwnerSession: boolean = false;
    controllingSpectator: boolean = false;
    spectators: string[] = [];
    name: string;

    initOptions: Options = {
        canvasMode: 'image',
        parseXMLResponse: true,
        emitXMLResponsesUnparsed: false,
        sendSessionReady: true,
        skipVSLogo: false,
        blockOnLoad: false,
        alwaysParkSessions: false,
        autoConnectToParkedSession: true
    }

    resizeTimeout: number

    vsCanvas: VSCanvas;
    wvInstanceId : number

    timerDelayingHQImage: number;
    command: CommandInstance;
    tickTime: number;

    target: HTMLElement;
    context: Window;

    offsetInterval: any;
    offsetX: number;
    offsetY: number;

    lastPagePos: Pos2D = {
        x: 0,
        y: 0
    }

    lastFileOpened: string;
    mouseX: number;
    mouseY: number;

    preResize: Function

    stats: Stats = undefined
    lang: string

    renderSelectionRect: boolean = false
    rectStarted: boolean = false

    isBackendMode: boolean = false

    //View handling
    views: ConfigurationViewsData[] = [];
    activeView: ConfigurationViewsData;
    selectedViews: ConfigurationViewsData[] = [];

    //UI blocker
    uiBlocker: HTMLElement;

    confirmPageLeave: boolean = false;

    //URL parameter
    query = {};
    licenseInfo: string = '';

    //Freeze
    disableFreezeParking: boolean = false;
    freezeParkTime: number = 14400;

    //WS Reconnect Limit
    reconnectAttempts = 0;
    maxReconnectAttempts = 10; // Limit reconnect attempts

    constructor() {
        super()
        this.tickTime = 20
        this.setMaxListeners(60);
        window.onbeforeunload = e => {
            if (this.isOwnerSession || this.controllingSpectator || this.confirmPageLeave) {
                e.preventDefault();
                e.returnValue = false;
            }
        }
        window.onunload = e => {
            if (this.isOwnerSession) {
                this.stopSessionSharing();
            }
            this.sessionTerminated = true;
            if (this.sessionInfo && this.sessionInfo.socket && this.sessionInfo.socket.readyState === 1 && !this.controllingSpectator) {
                if (this.initOptions.alwaysParkSessions)
                {
                    let parkCall = '<Request Type="Park"><Timeout>7</Timeout></Request>';
                    let prefix = '';
                    try
                    {
                        let oldTimes = sessionStorage.getItem('UnloadPark');
                        if (oldTimes && oldTimes !== null)
                        {
                            prefix = oldTimes + ' | ';
                        }
                    }
                    catch(e){}
                    sessionStorage.setItem('UnloadPark', prefix + new Date().toLocaleString());
                    this.sessionInfo.socket.send(parkCall);
                }
                else
                {
                    let prefix = '';
                    try
                    {
                        let oldTimes = sessionStorage.getItem('UnloadPark');
                        if (oldTimes && oldTimes !== null)
                        {
                            prefix = oldTimes + ' | ';
                        }
                    }
                    catch (e) { }
                    try
                    {
                        sessionStorage.setItem('lastSessionId_'+ this.wvInstanceId, this.session);
                        sessionStorage.removeItem('sessionId_'+ this.wvInstanceId);
                    }
                    catch(e){}
                    sessionStorage.setItem('UnloadClose', prefix + new Date().toLocaleString());
                    this.sendBinaryPackage(1, PAYLOAD_TYPE_BINARY.TerminateClient, "0");
                }
            }
        }

        document.addEventListener('freeze', e =>
        {
            if (!this.initOptions.disableFreezeParking)
            {
                console.log('Tab frozen: ' + new Date().toLocaleString());
                console.log('WebSocket parked for ' + this.freezeParkTime + ' seconds.')
                sessionStorage.setItem('FrozenAt', new Date().toLocaleString());
                if (this.initOptions.freezeParkTime)
                {
                    this.freezeParkTime = this.initOptions.freezeParkTime;
                }
                this.sessionTerminated = true;
                let parkCall = '<Request Type="Park"><Timeout>' + this.freezeParkTime + '</Timeout></Request>';
                let logCall = '<Call Method="LogMessage"><Message>Session parked for ' + this.freezeParkTime + ' seconds due to tab freeze.</Message><Level>Info</Level></Call>';
                this.command.executeXMLAsync(logCall);
                this.sessionInfo.socket.send(parkCall);
                this.sessionInfo.socket.close();
            }
        });

        document.addEventListener('resume', e =>
        {
            if (!this.initOptions.disableFreezeParking)
            {
                console.log('Tab resumes at : ' + new Date().toLocaleString());
                console.log('WebSocket resumed.')
                this.retry();
            }
        });

        //Parse the URL
        let queryString = window.location.search.substr(1);
        let kvs = queryString.split('&');
        for (let kv of kvs) {
            let [k, v] = kv.split('=');
            this.query[k] = v;
        }

        //Check the query
        if (this.query['licenseInfo']) {
            this.licenseInfo = decodeURIComponent(escape(window.atob(this.query['licenseInfo'])));
        }

        if (location.hash.indexOf('licenseInfo') !== -1) {
            this.checkLicenseInfoFromHash();
        }

        window.onhashchange = e => {
            if (location.hash.indexOf('licenseInfo') !== -1) {
                this.checkLicenseInfoFromHash();
            }
        }
    }

    retry() {

        this.reconnectAttempts++;

        const delay: number = Math.min(9000, (Math.random() * 1000) * this.reconnectAttempts); // Max delay of 9 seconds

        setTimeout(() => {
            console.log(`Reconnecting... ID ${this.wvInstanceId} Delay ${delay}  Attempt #${this.reconnectAttempts}`);
            try {
                this.initSocket(wsUrl, true);
            }
            catch (e) {
                //this.retry();
            }
        }, delay);
    }

    initialize(el: HTMLElement, wsAddress: WebSocketAddress, options?: Options, context?: Window) {

        if (!(el instanceof HTMLElement)) {
            throw (logMsg + `the first parameter must be a valid HTMLElement`)
        }

        this.wvInstanceId = this.countElementsByClass('2DCanvas'); // Use class 2DCanvas count before initialize as ID for this WV instance
        console.log(`Initialize WV instance ID ${this.wvInstanceId}`);

        this.on('@changeLang', (lang) => {
            this.lang = lang
        })

        this.target = el
        let offset = findTheOffset(this.target)
        this.offsetX = offset.x
        this.offsetY = offset.y

        this.offsetInterval = setInterval(() => {
            let offset = findTheOffset(this.target)
            this.offsetX = offset.x
            this.offsetY = offset.y
        }, 1000)

        this.context = context || window

        if (typeof options !== 'undefined') {
            for (let name in options) {
                this.initOptions[name] = options[name]
            }
        }

        this.sessionInfo.canvasMode = this.initOptions.canvasMode

        this.stats = new Stats(this.context)

        this.stats.onBadCond = () => {
            this.sessionInfo.compressionLQ = Math.max(50, Math.round(this.sessionInfo.compressionLQ * 0.6))
            this.sessionInfo.compressionHQ = Math.max(90, Math.round(this.sessionInfo.compressionHQ * 0.8))
            if (this.sessionInfo.compressionLQ !== 50 || this.sessionInfo.compressionHQ !== 90) {
                this.setQuality(this.sessionInfo.compressionLQ, this.sessionInfo.compressionHQ)
            }
        }

        this.stats.onGoodCond = () => {
            this.sessionInfo.compressionLQ = Math.min(80, Math.round(this.sessionInfo.compressionLQ * 1.2))
            this.sessionInfo.compressionHQ = Math.min(99, Math.round(this.sessionInfo.compressionHQ * 1.5))
            if (this.sessionInfo.compressionLQ !== 80 || this.sessionInfo.compressionHQ !== 99) {
                this.setQuality(this.sessionInfo.compressionLQ, this.sessionInfo.compressionHQ)
            }
        }


        this.vsCanvas = new VSCanvas(this.target, this, this.context);
        this.vsCanvas.setMode(this.sessionInfo.canvasMode);
        this.sessionInfo.canvasWidth = this.vsCanvas.width;
        this.sessionInfo.canvasHeight = this.vsCanvas.height;

        //Try to get session from session storage
        try
        {
            if (this.initOptions.autoConnectToParkedSession)
            {
                let sessionId = sessionStorage.getItem('sessionId_' + this.wvInstanceId);
                if (sessionId && sessionId !== null)
                {
                    this.session = sessionId;
                }
            }
        }
        catch (e){}

        this.initSocket(wsAddress);
        this.on('SessionInitialized', (res) =>
        {
            this.session = (this.initOptions.spectatorMode || this.controllingSpectator) && res.Spectator ? res.Spectator : res.Session;
            sessionStorage.setItem('sessionId_' + this.wvInstanceId, this.session);
            this.sessionFromStorage = true;
            this.command.resetMouseMove();
            if (this.initOptions.sendSessionReady)
            {
                const SendSessionReady = `
					<Call Method="SendSessionReady">
					</Call>
				`;
                this.command.executeXMLNoMirror(SendSessionReady);
            }
        });

        //Listen for server relyed messages
        this.on('Relay', res => {
            let message = res.__text__;
            //Session destroy command
            if (message === 'WebViewer_SessionKill') {
                this.destroy();
                window.open('/session_terminated_index.html' + location.search, "_self");
            }
        });
    }


    initSocket(address, retry?: boolean) {
        wsUrl = address;
        //Try to get session from session storage
        let sessionId = null;
        try
        {
            if (this.initOptions.autoConnectToParkedSession)
            {
                sessionId = sessionStorage.getItem('sessionId_' + this.wvInstanceId);
                if (sessionId && sessionId !== null)
                {
                    this.session = sessionId;
                }
            }
        }
        catch (e) { }
        if (retry || sessionId)
        {
            this.on('SessionInfo', res => {
                if (!this.initOptions.routeOnRetriedAuthenticationFail)
                {
                    let url = location.href.split('/');
                    url.pop();
                    if (sessionId)
                    {
                        sessionStorage.removeItem('sessionId_'+ this.wvInstanceId)
                    }
                    window.open(url.join('/') + '/session_terminated_index.html' + location.search, "_self");
                }
                this.sessionTerminated = true;
                this.emit('RetryFailedOnAuthentication', 'Authentication on retried socket connection failed.');
            });
        }
        try {
            this.sessionInfo.socket = new WebSocket(address);
        }
        catch (error) {
            this.emit('ConnectionLost');
            return;
        }
        this.sessionInfo.socket.binaryType = 'arraybuffer';


        this.sessionInfo.socket.onopen = () => {

            console.log(`WebSocket ID ${this.wvInstanceId} open`);
            this.reconnectAttempts = 0; // Reset the reconnect attempts on successful connection

            this.command = new Command(this.sessionInfo.socket, this);
            if (this.session) {
                this.initOptions.sessionToConnect = this.session;
            }
            this.connect(this.initOptions.spectatorMode || this.controllingSpectator);
            this.sessionInfo.commandTimer = this.context.setInterval(this.command.sendXML.bind(this), this.tickTime);

            // WS indicator change on WS established
            if (!retry) {
                this.emit('initialized', this.sessionInfo);
                //Register events for scene blocker
                if (this.initOptions.blockOnLoad) {
                    this.on('AsyncEventBegin', res => {
                        if (res.BlockingOperation === "1" && res.Id === 'ImportSync') {
                            this.blockUI();
                        }
                    });
                    this.on('AsyncEventEnd', res => {
                        if (res.Id === 'ImportSync') {
                            this.unblockUI();
                        }
                    });
                }
            }
            else {
                this.emit('ConnectionRestored', this.sessionInfo);
            }
        }
        this.sessionInfo.socket.onclose = () => {
            $(".ws_indicator").css('fill', 'red');
            this.emit('ConnectionLost');
            if (!this.sessionTerminated && !this.initOptions.preventRetry) {

                console.log(`WebSocket closed ID ${this.wvInstanceId}. Attempting to reconnect...`);
                if (this.reconnectAttempts < this.maxReconnectAttempts) {
                    this.retry();
                } else {
                    console.log('Max reconnect attempts reached. Giving up.');
                }
            }
        }
        this.sessionInfo.socket.onmessage = this.mainHandler.bind(this);
        if (!retry) {
            var img = new Image();
            var ctx = this.vsCanvas.canvas2D.getContext('2d');
            if (!this.initOptions || (this.initOptions && !this.initOptions.skipVSLogo)) {
                img.src = 'vs_logo.svg';
                img.onload = () => {

                    if (this.vsCanvas.width > 20 && this.vsCanvas.height > 20) {
                        var logoWidth;
                        if (this.vsCanvas.width <= this.vsCanvas.height) {
                            logoWidth = this.vsCanvas.width / 2;
                        }
                        else {
                            logoWidth = this.vsCanvas.height / 2;
                        }
                        var posX = (this.vsCanvas.width - logoWidth) / 2;
                        var posY = (this.vsCanvas.height - logoWidth) / 2;
                        ctx.drawImage(img, posX, posY, logoWidth, logoWidth);
                    }
                }
            }
            //UI blocker
            this.uiBlocker = document.createElement('div');
            this.uiBlocker.className = 'canvas-loading-wrapper';

            let spinnerIcon = document.createElement('i');
            spinnerIcon.className = 'canvas-loading-icon fal fa-spinner-third fa-spin';
            this.uiBlocker.appendChild(spinnerIcon);
        }
    }

    connect(spectate?: boolean) {
        let client: string = this.initOptions.client ? '<Client>' + this.initOptions.client + '</Client>' : "";
        let sessionId: string = this.initOptions.sessionToConnect ? this.initOptions.sessionToConnect : '';
        let sessionParam: string = (spectate && this.session) ? '<Spectator>' + sessionId + '</Spectator>' : '<Session>' + sessionId + '</Session>';
        let connectionParamter = spectate ? '<ConnectionType>Spectate="true"</ConnectionType>' : '';
        //Check if license info should be passed
        let licenseInfoString = (this.licenseInfo !== '' && sessionId === '') ? '<Username>' + this.licenseInfo + '</Username>' : '';
        let connectCall = '<Request Type="Connect">' + sessionParam + client + licenseInfoString + connectionParamter + '</Request>';
        this.command.executeXML(connectCall);
    }

    closeParkedSession(clientId: string)
    {
        if (this.session)
        {
            try
            {
                sessionStorage.setItem('lastSessionId_'+ this.wvInstanceId, this.session);
                sessionStorage.removeItem('sessionId_'+ this.wvInstanceId);
            }
            catch (e) { }
            this.sessionInfo.socket = new WebSocket(wsUrl);
            this.sessionInfo.socket.onopen = () =>
            {
                this.command = new Command(this.sessionInfo.socket, this);
                let xml = '<Request Type="Connect"></Request><Request Type="CloseSessions">';
                xml += '<Client>' + clientId + '</Client>';
                xml += '<Session>' + this.session + '</Session></Request>';
                this.command.executeXML(xml);
                this.sessionInfo.commandTimer = this.context.setInterval(this.command.sendXML.bind(this), this.tickTime);
            }
        }
    }

    destroy() {
        this.sessionTerminated = true;
        //Close session
        if (this.sessionInfo && this.sessionInfo.socket && this.sessionInfo.socket.readyState === 1) {
            this.sendBinaryPackage(1, PAYLOAD_TYPE_BINARY.TerminateClient, "0");
        }
        //Remove event listener
        this.removeAllListeners();
        //Stop intervals
        clearInterval(this.offsetInterval);
        clearInterval(this.command.sendXML.bind(this));
        clearInterval(this.sessionInfo.commandTimer);
        this.context.clearInterval(this.sessionInfo.commandTimer);
        this.context.clearInterval((this.command.sendXML.bind(this)));
        //Terminate sub-classes
        this.stats.worker.terminate();
        this.command.destroy();
        this.command = null;
        //Kill eventhandler
        this.setDefaultMouse(-1);
        this.unregisterContextMenu();
        //Remove canvas
        this.vsCanvas.destroy();
        //Kill websocket
        this.sessionInfo.socket.close();
        //Remove blocker
        $(this.uiBlocker).remove();
        this.uiBlocker = undefined;
        //Reset variables
        this.reset();
    }

    reset() {
        this.tickTime = 0;
        this.target = null;
        this.offsetX = null;
        this.offsetY = null;
        this.context = null;
        this.views = [];
        this.activeView = null;
        this.initOptions = {
            canvasMode: 'image',
            parseXMLResponse: true,
            emitXMLResponsesUnparsed: false,
            sendSessionReady: true,
            skipVSLogo: false
        };
        this.sessionInfo = {
            socket: undefined,
            commandTimer: 0,
            canvasMode: 'image',
            compressionLQ: 50,
            compressionHQ: 95,
            canvasWidth: 0,
            canvasHeight: 0,
            firstImageRecieved: false,
            token: ''
        };
        this.stats = null;
        this.command = null;
        this.vsCanvas = null;
    }

    countElementsByClass(className: string) {
        const elements = document.getElementsByClassName(className);
        return elements.length;
    }

    registerContextMenu() {
        this.vsCanvas.registerContextMenu();
    }

    unregisterContextMenu() {
        this.vsCanvas.unregisterContextMenu();
    }

    restore(el: HTMLElement, sessionInfo: SessionInfo, context?: Window) {

        if (!(el instanceof HTMLElement)) {
            throw (logMsg + `the first parameter must be a valid HTMLElement`)
        }
        if ((el.offsetWidth === 0 || el.offsetHeight === 0)) {
            console.log(logMsg + `warning, size of element is zero`)
        }

        if (sessionInfo.socket.readyState !== 1) {// not "OPEN"
            console.error(logMsg + `no active WebSocket connection, call restore() only on the opened WebSocket connection`)
            return
        }

        this.target = el
        let offset = findTheOffset(this.target)
        this.offsetX = offset.x
        this.offsetY = offset.y

        this.context = context || window

        this.stats = new Stats(this.context)

        this.stats.onBadCond = () => {
            this.sessionInfo.compressionLQ = Math.max(50, Math.round(this.sessionInfo.compressionLQ * 0.6))
            this.sessionInfo.compressionHQ = Math.max(90, Math.round(this.sessionInfo.compressionHQ * 0.8))
            if (this.sessionInfo.compressionLQ !== 50 || this.sessionInfo.compressionHQ !== 90) {
                this.setQuality(this.sessionInfo.compressionLQ, this.sessionInfo.compressionHQ)
            }
        }

        this.stats.onGoodCond = () => {
            this.sessionInfo.compressionLQ = Math.min(80, Math.round(this.sessionInfo.compressionLQ * 1.2))
            this.sessionInfo.compressionHQ = Math.min(99, Math.round(this.sessionInfo.compressionHQ * 1.5))
            if (this.sessionInfo.compressionLQ !== 80 || this.sessionInfo.compressionHQ !== 99) {
                this.setQuality(this.sessionInfo.compressionLQ, this.sessionInfo.compressionHQ)
            }
        }

        this.vsCanvas = new VSCanvas(this.target, this, this.context)
        this.vsCanvas.setMode(this.sessionInfo.canvasMode)

        this.sessionInfo = sessionInfo
        // setup the timer
        this.command = new Command(this.sessionInfo.socket, this)
        this.context.clearInterval(this.sessionInfo.commandTimer)
        this.sessionInfo.commandTimer = this.context.setInterval(this.command.sendXML.bind(this), this.tickTime)
        this.sessionInfo.socket.onmessage = this.mainHandler.bind(this)

        this.sessionInfo.canvasWidth = this.vsCanvas.width
        this.sessionInfo.canvasHeight = this.vsCanvas.height
        this.resize(this.sessionInfo.canvasWidth, this.sessionInfo.canvasHeight)

        this.emit('restored', this.sessionInfo)
    }

    mainHandler(ev: MessageEvent) {
        if (ev.data instanceof ArrayBuffer) {
            this.parseBinaryServerMessage(<ArrayBuffer>ev.data)
        } else if (typeof ev.data === 'string') {
            if (ev.data.length > 0) {
                if (ev.data.indexOf('ClientId') !== -1) {
                    this.isBackendMode = true;
                }
                this.parseTextServerMessage(ev.data)
                this.command.allowSending()
            }
        }
    }

    parseBinaryServerMessage(data: ArrayBuffer) {
        let headerLength = 12
        let header = new Uint8Array(data, 0, headerLength)

        // the last two bytes
        let messageType = header[headerLength - 2]
        let payloadType = header[headerLength - 1]

        if (MESSAGE_TYPE.Push === messageType) {
            switch (payloadType) {
                case PAYLOAD_TYPE_BINARY.Image:
                    let encodingState = (new DataView(data, headerLength, 4)).getUint32(0, true)

                    switch (encodingState) {
                        case CODEC_STATUS.JPG:
                            // let timestamp = convertBigEndianUInt64ToNumber(new Uint8Array(data, 2, 8))
                            this.stats.logImageArrival(Date.now())
                        case CODEC_STATUS.HQJPG:
                            {
                                if (encodingState === CODEC_STATUS.HQJPG) {
                                    this.stats.logImageHalt()
                                    this.emit('RendererIdle');
                                }
                                let image = "data:image/jpeg;base64," + base64ArrayBuffer(data, headerLength + 4, data.byteLength - headerLength - 4)
                                this.vsCanvas.putImage(image);

                                if (!this.sessionInfo.firstImageRecieved) {
                                    this.sessionInfo.firstImageRecieved = true
                                }
                            }
                            break;

                        case CODEC_STATUS.PNG:
                            {
                                this.emit('RendererIdle');
                                let image = "data:image/png;base64," + base64ArrayBuffer(data, headerLength + 4, data.byteLength - headerLength - 4)
                                this.vsCanvas.putImage(image);

                                if (!this.sessionInfo.firstImageRecieved) {
                                    this.sessionInfo.firstImageRecieved = true
                                }
                            }
                            break;

                        case CODEC_STATUS.H264:
                            let nWidth = (new Uint16Array(data, headerLength + 4, 2))[0]
                            let nHeight = (new Uint16Array(data, headerLength + 6, 2))[0]

                            if (nWidth !== this.vsCanvas.scaledWidth || nHeight !== this.vsCanvas.scaledHeight) {
                                this.vsCanvas.scaledWidth = nWidth
                                this.vsCanvas.scaledHeight = nHeight
                                this.vsCanvas.decoder.restartWorker()
                                this.stats.logDecoderStart()
                            }

                            let video = new Uint8Array(data, headerLength, data.byteLength - headerLength)
                            this.vsCanvas.putH264NALU(video);
                            break;
                    }
                    this.command.allowSending()
                    break;

                case PAYLOAD_TYPE_BINARY.Tree:
                    let treeviewInfo = this.parseTreeviewBinary(data, headerLength, data.byteLength - headerLength)
                    this.emit('TreeviewUpdated', treeviewInfo)
                    this.command.allowSending()
                    break;

                case PAYLOAD_TYPE_BINARY.GeneralResponse:
                    {
                        let nMessage = (new DataView(data, headerLength, 1)).getUint8(0)
                        if (nMessage == 1) {
                            this.command.allowSending()
                        }
                    }
                    break;
            }
        } else if (MESSAGE_TYPE.Response === messageType) {
            switch (payloadType) {
                case (PAYLOAD_TYPE_BINARY.Pong):
                    let lastClientTimestampBytes = new Uint8Array(data, headerLength, 8)
                    let lastClientTimestamp = convertBigEndianUInt64ToNumber(lastClientTimestampBytes)
                    let currentTimestamp = Date.now()
                    let rtt = currentTimestamp - lastClientTimestamp
                    //Calculate how many Pings are sent during a second
                    let pingsPerSecond = 1000 / rtt
                    //Reduce tick time when the amount of pings per second is already below the tick rate
                    if (pingsPerSecond < this.tickTime) {
                        while (pingsPerSecond < this.tickTime && this.tickTime > 5) {
                            this.tickTime -= 5
                        }
                        clearInterval(this.sessionInfo.commandTimer);
                        this.sessionInfo.commandTimer = this.context.setInterval(this.command.sendXML.bind(this), this.tickTime)
                    }
                    else {
                        while (pingsPerSecond > this.tickTime && this.tickTime < 20) {
                            this.tickTime += 5
                        }
                        clearInterval(this.sessionInfo.commandTimer);
                        this.sessionInfo.commandTimer = this.context.setInterval(this.command.sendXML.bind(this), this.tickTime)
                    }
                    this.stats.logRTT(rtt)
                    break;
                case (PAYLOAD_TYPE_BINARY.GetFolderContent):
                    let charArray = new Uint8Array(data, headerLength)
                    let responseString = String.fromCharCode.apply(null, charArray)
                    responseString = decodeURIComponent(escape(responseString))
                    let folderContent;
                    try {
                        folderContent = JSON.parse(responseString)
                    }
                    catch (e) {
                        folderContent = [];
                    }
                    this.emit('GetFolderContent', folderContent)

                    if (responseString == 1) {
                        this.command.allowSending()
                    }
                    break
                case (PAYLOAD_TYPE_BINARY.GetFolderFileCount):
                    let folderCount = new Uint32Array(data)[3]
                    this.emit('GetFolderFileCount', folderCount)
                    break;
                case (PAYLOAD_TYPE_BINARY.SearchByString):
                    // not finished. But a start to get an idea. Talk to Tomas for more information
                    let searchResponse = new Uint32Array(data)
                    let searchResult = String.fromCharCode.apply(null, charArray).slice(11)
                    this.emit('SearchByString', searchResult)
                    break;
            }
        }
    }

    parseTextServerMessage(sXml: string) {
        this.emit('@recvXML', sXml, Date.now());
        let iPosHeaderEnd = sXml.indexOf(">");
        let iPosPayloadEnd = sXml.lastIndexOf("<");
        if (-1 == iPosHeaderEnd || -1 == iPosPayloadEnd) {
            console.log("Invalid header")
            return;
        }
        var sHeader = sXml.substring(0, iPosHeaderEnd) + "/>";
        var sPayload = "<XML>" + sXml.substring(iPosHeaderEnd + 1, iPosPayloadEnd) + "</XML>"

        var jsObj = parseXML(sHeader)


        var nMessageType
        var sPayloadType
        var message
        var jsPayload
        // Changing Connection indicator by response
        $(".ws_indicator").removeClass("ws_indicator_animate")
        //License error handling
        if (jsObj && jsObj.Response && jsObj.Response.Type && jsObj.Response.Type === "SessionInfo") {
            if (sPayload.indexOf("Denied") !== -1) {
                this.sessionTerminated = true;
                this.emit('LicenseError', 'Session start was denied because a license error occured.');
                try {
                    let url = location.href.split('/');
                    url.pop();
                    switch (_AlternateLicenseErrorHandling) {
                        case 0:
                            window.open(url.join('/') + '/license_error_index.html' + location.search, "_self");
                            break;
                        case 1:
                            window.open(url.join('/') + '/license_error_index.html' + location.search);
                            break;
                        case 2:
                            console.error('License error occured!');
                            break;
                        default:
                            window.open(url.join('/') + '/license_error_index.html' + location.search, "_self");
                            break;
                    }
                }
                catch (err) {
                    window.open('/license_error_index.html' + location.search, "_self");
                    console.error('License error occured!');
                }
            }
            else if (sPayload.indexOf("AllSessionsInUse") !== -1) {
                this.sessionTerminated = true;
                this.emit('AllLicensesUsedError', 'Session start was denied because the license limit was exceeded.');
                try {
                    let url = location.href.split('/');
                    url.pop();
                    //Test if a parked session should exist
                    let sessionId: string = null;
                    try
                    {
                        if (this.initOptions.autoConnectToParkedSession)
                        {
                            sessionId = sessionStorage.getItem('sessionId_' + this.wvInstanceId);
                            if (sessionId && sessionId !== null)
                            {
                                this.session = sessionId;
                            }
                        }
                    }
                    catch (e) { }
                    if (sessionId !== null)
                    {
                        this.emit('NoLicenseForParkedSession', sessionId);
                    }
                    else
                    {
                        switch (_AlternateLicenseErrorHandling)
                        {
                            case 0:
                                window.open(url.join('/') + '/licenses_exceeded_error_index.html' + location.search, "_self");
                                break;
                            case 1:
                                window.open(url.join('/') + '/licenses_exceeded_error_index.html' + location.search);
                                break;
                            case 2:
                                console.error('All licenses are in use!');
                                break;
                            default:
                                window.open(url.join('/') + '/licenses_exceeded_error_index.html' + location.search, "_self");
                                break;
                        }
                    }
                }
                catch (err) {
                    window.open('/licenses_exceeded_error_index.html' + location.search, "_self");
                    console.error('All licenses are in use!');
                }
            }
        }

        if (jsObj.hasOwnProperty(MESSAGE_TYPE.toString(MESSAGE_TYPE.Push))) {
            nMessageType = MESSAGE_TYPE.Push
            message = jsObj.Push;
        } else if (jsObj.hasOwnProperty(MESSAGE_TYPE.toString(MESSAGE_TYPE.Response))) {
            nMessageType = MESSAGE_TYPE.Response;
            message = jsObj.Response;
        } else if (jsObj.hasOwnProperty(MESSAGE_TYPE.toString(MESSAGE_TYPE.Request))) {
            nMessageType = MESSAGE_TYPE.Request;
            console.log("Request not implemented")
            return;
        } else {
            console.log("Invalid header")
            return;
        }

        sPayloadType = message.Type

        if (MESSAGE_TYPE.Push === nMessageType) {
            switch (sPayloadType) {
                case PAYLOAD_TYPE_TEXT.toString(PAYLOAD_TYPE_TEXT.XMLEvent):
                    this.emit(sPayloadType, sPayload)

                    jsPayload = parseXML(sPayload)

                    if (jsPayload.XML.hasOwnProperty("Event")) {
                        let EventArray = []

                        if (Array.isArray(jsPayload.XML.Event)) {
                            EventArray = jsPayload.XML.Event;
                        }
                        else {
                            EventArray.push(jsPayload.XML.Event);
                        }

                        for (let iEvent = 0; iEvent < EventArray.length; iEvent++) {

                            var Event = EventArray[iEvent];

                            let PushEvent = Event.Type
                            if (Array.isArray(PushEvent)) {
                                PushEvent = PushEvent[0];
                            }
                            this.emit(PushEvent, Event, sPayload)
                        }
                    }
                    break;
            }
        }
        else if (MESSAGE_TYPE.Response === nMessageType) {
            switch (sPayloadType) {
                case PAYLOAD_TYPE_TEXT.toString(PAYLOAD_TYPE_TEXT.XMLResponse):

                    if (this.initOptions.parseXMLResponse) {
                        let responses = this.parseXMLResponse(sPayload) // XML
                        this.emit('JSONResponse', responses)
                        for (var i = 0; i < responses.length; i++) {
                            if (!responses[i]['Method']) {
                                continue;
                            }
                            let method = responses[i]['Method'];
                            if (method) {

                                let parameterType = ''

                                if (method in WithTypeParameters) {
                                    parameterType = '.' + responses[i]['Type']
                                }

                                if (responses[i]['CustomId'] && responses[i]['Method'] === 'MouseMove') {
                                    this.command.setMouseMove(false);
                                }
                                else if (!responses[i]['CustomId'] && responses[i]['Method'] === 'MouseMove') {
                                    this.command.setMouseMove(true);
                                }
                                this.emit(responses[i]['Method'] + parameterType, responses[i], sPayload)
                            }
                        }
                    }
                    if (this.initOptions.emitXMLResponsesUnparsed) {
                        this.emit('XMLResponse', sPayload)
                    }

                    break;

                case PAYLOAD_TYPE_TEXT.toString(PAYLOAD_TYPE_TEXT.ServerResponse):
                    this.emit(sPayloadType, sPayload)
                    break;

                case PAYLOAD_TYPE_TEXT.toString(PAYLOAD_TYPE_TEXT.InstanceResponse):
                    this.emit(sPayloadType, sPayload)
                    break;

                default:
                    // ignore
                    break

            }
        }
        return;
    }

    parseXMLResponse(XML: string) {
        var data = parseXML(XML).XML
        var result = []


        if ((typeof data.Response === 'undefined') && (typeof data.ResponseList === 'undefined')) {
            throw 'no response'
        }

        if (typeof data.ResponseList !== 'undefined' && data.ResponseList !== '') {

            if (Array.isArray(data.ResponseList)) {
                for (var i = 0; i < data.ResponseList.length; i++) {
                    if (Array.isArray(data.ResponseList[i].Response)) {
                        for (var j = 0; j < data.ResponseList[i].Response.length; j++) {
                            result.push(data.ResponseList[i].Response[j])
                        }
                    } else {
                        result.push(data.ResponseList[i].Response)
                    }
                }
            } else if (Array.isArray(data.ResponseList.Response)) {
                for (var i = 0; i < data.ResponseList.Response.length; i++) {
                    result.push(data.ResponseList.Response[i])
                }
            } else {
                result.push(data.ResponseList.Response)
            }
        }

        if (typeof data.Response !== 'undefined') {
            //WORKAROUND if the server isn't able to wrap a list in a list wrapper
            if (Array.isArray(data.Response)) {
                for (let i = 0; i < data.Response.length; i++) {
                    result.push(data.Response[i]);
                }
            }
            else {
                result.push(data.Response)
            }
        }

        return result
    }

    parseTreeviewBinary(arrayBuffer: ArrayBuffer, byteOffset: number, byteLength: number) {
        var treeviewInfo = {
            'ExpandedNodes': 0
            , 'VirtualScrollPosition': 0
            , 'Items': []
        }

        var dataLength = byteLength
        var dataView = new DataView(arrayBuffer, byteOffset, dataLength)
        var offset = 0
        var isInternal = dataView.getUint8(offset);
        offset += 1
        treeviewInfo.ExpandedNodes = dataView.getUint32(offset, true)
        offset += 4
        treeviewInfo.VirtualScrollPosition = dataView.getUint32(offset, true)
        offset += 4

        var nodeId
        var level
        var expanderState
        var visibility
        var nodeType
        var selection
        var cutState

        var nodeNameSize
        var charArray
        var nodeName

        //Internal mode only variables
        var idLength
        var nodeIdArr

        while (offset !== dataLength) {
            if (isInternal === 1) {
                idLength = dataView.getUint8(offset)
                offset += 1
                nodeIdArr = new Uint8Array(arrayBuffer, byteOffset + offset, idLength);
                nodeId = String.fromCharCode.apply(null, nodeIdArr);
                nodeId = decodeURIComponent(escape(nodeId));
                offset += idLength
            }
            else {
                nodeId = dataView.getUint32(offset, true)
                offset += 4
            }
            level = dataView.getUint8(offset)
            offset += 1
            expanderState = dataView.getUint8(offset)
            offset += 1
            visibility = dataView.getUint8(offset)
            offset += 1
            nodeType = dataView.getUint8(offset)
            offset += 1
            selection = dataView.getUint8(offset)
            offset += 1
            cutState = dataView.getUint8(offset)
            offset += 1
            nodeNameSize = dataView.getUint8(offset)
            offset += 1

            charArray = new Uint8Array(arrayBuffer, byteOffset + offset, nodeNameSize)
            nodeName = String.fromCharCode.apply(null, charArray)
            nodeName = decodeURIComponent(escape(nodeName)) // escape(nodeName) ?

            offset += nodeNameSize

            treeviewInfo.Items.push({
                'NodeId': nodeId
                , 'Level': level
                , 'ExpanderState': expanderState
                , 'Visibility': visibility
                , 'NodeType': nodeType
                , 'Selection': selection
                , 'IsCutted': cutState
                , 'NodeName': nodeName
            })
        }

        return treeviewInfo
    }

    setDefaultMouse(enabled: number) {
        let el = this.target

        if (enabled == 1) {
            el.addEventListener('mousedown', this.mousedownHandler)
            el.addEventListener('mousemove', this.mousemoveHandler)
            el.addEventListener('mouseup', this.mouseupHandler)
            el.addEventListener('dblclick', this.dblclickHandler)
            el.addEventListener('wheel', this.wheelHandler)
            el.addEventListener('mouseleave', this.mouseupHandler)
        }
        else if (enabled == 2) {
            el.addEventListener('mousedown', this.mousedownHandler)
            el.addEventListener('mousemove', this.mousemoveHandler)
            el.addEventListener('mouseup', this.mouseupHandler)
            // el.addEventListener('dblclick', this.dblclickHandler)
            el.addEventListener('wheel', this.wheelHandler)
            el.addEventListener('mouseleave', this.mouseupHandler)
        }
        else if (enabled == 3) {
            el.addEventListener('mousedown', this.mousedownHandler)
            el.addEventListener('mousemove', this.mousemoveHandler)
            el.addEventListener('mouseup', this.mouseupHandler)
            el.addEventListener('dblclick', this.dblclickHandler)
            el.addEventListener('wheel', this.wheelHandler)
            el.addEventListener('touchstart', this.touchstartHandler, false)
            el.addEventListener('touchend', this.touchendHandler, false)
            el.addEventListener('touchmove', this.touchmoveHandler, false)
            el.addEventListener('mouseleave', this.mouseupHandler)
        }
        else {
            el.removeEventListener('mousedown', this.mousedownHandler)
            el.removeEventListener('mousemove', this.mousemoveHandler)
            el.removeEventListener('mouseup', this.mouseupHandler)
            el.removeEventListener('dblclick', this.dblclickHandler)
            el.removeEventListener('wheel', this.wheelHandler)
            el.removeEventListener('mouseleave', this.mouseupHandler)
            el.removeEventListener('touchstart', this.touchstartHandler, false)
            el.removeEventListener('touchend', this.touchendHandler, false)
            el.removeEventListener('touchmove', this.touchmoveHandler, false)
            this.vsCanvas.unregisterContextMenu();
        }
    }

    getTransferMode(): CanvasMode {
        return this.sessionInfo.canvasMode
    }

    setTransferMode(canvasMode: CanvasMode): boolean {
        let succeeded = this.vsCanvas.setMode(canvasMode)

        if (succeeded) {
            this.sessionInfo.canvasMode = canvasMode
            let serverEncodingMode: string = toServerEncoding(this.sessionInfo.canvasMode)
            const switchCall = `<Call Method="SetEncodingState"><EncodingState>${serverEncodingMode}</EncodingState></Call>`
            this.command.executeXML(switchCall)
        }

        return succeeded
    }

    resize(width: number, height: number, callResize: boolean = true) {

        if (typeof this.preResize === 'function') {
            this.preResize.call(this);
        }

        if (this.vsCanvas) {
            this.vsCanvas.resize(width, height);
            this.sessionInfo.canvasWidth = this.vsCanvas.width;
            this.sessionInfo.canvasHeight = this.vsCanvas.height;

            var width = this.vsCanvas.width;
            var height = this.vsCanvas.height;

            if (width < 1) {
                width = 1;
            }

            if (height < 1) {
                height = 1;
            }

            clearTimeout(this.resizeTimeout);

            this.resizeTimeout = window.setTimeout(() => {
                if (this.command && callResize) {
                    const XML = '<Call Method="Resize"><Width>' + width + '</Width><Height>' + height + '</Height></Call>';
                    this.command.executeXML(XML);
                }
            }, 10);
        }
    }

    AutoResize() {
        if (typeof this.preResize === 'function') {
            this.preResize.call(this)
        }

        var width = this.sessionInfo.canvasWidth
        var height = this.sessionInfo.canvasHeight

        if (width < 1) {
            width = 1;
        }

        if (height < 1) {
            height = 1;
        }

        const XML = '<Call Method="Resize"><Width>' + width + '</Width><Height>' + height + '</Height></Call>'
        this.command.executeXML(XML)
    }

    SessionToken(token: string) {
        var width = this.vsCanvas.width
        var height = this.vsCanvas.height

        if (width < 1) {
            width = 1
        }
        if (height < 1) {
            height = 1
        }
        this.sessionInfo.token = token;

        this.vsCanvas.resize(width, height)

        let serverEncodingMode = toServerEncoding(this.sessionInfo.canvasMode)

        this.setQuality(this.sessionInfo.compressionLQ, this.sessionInfo.compressionHQ)

        var AuthenticationRequest = "<Request Type='AuthenticateSession'><Token>" + token + "</Token></Request>"
        console.log("WV Client send token requesting authentication :" + AuthenticationRequest)

        this.command.executeXML(AuthenticationRequest);
    }

    New3DView() {
        this.NewScene3D()
    }

    NewScene3D() {

        var width = this.vsCanvas.width
        var height = this.vsCanvas.height

        if (width < 1) {
            width = 1;
        }

        if (height < 1) {
            height = 1;
        }

        this.vsCanvas.resize(width, height)

        let serverEncodingMode = toServerEncoding(this.sessionInfo.canvasMode)

        // image quality
        this.setQuality(this.sessionInfo.compressionLQ, this.sessionInfo.compressionHQ)

        // open file
        var xml = '<Call Method="NewScene3D"><Width>' + width + '</Width><Height>' + height + '</Height><EncodingState>'
            + serverEncodingMode + '</EncodingState></Call>'

        xml += '<Call Method="AddEventListener">'
        xml += '<Event>ActivateInteraction</Event>'
        xml += '<Event>DeactivateInteraction</Event>'
        xml += '<Event>NodePropertiesChanged</Event>'
        xml += '<Event>SelectionChanged</Event>'
        xml += '<Event>SelectionChangedCustomId</Event></Call>'

        this.command.executeXMLAsync(xml)
    }

    serializeFileToCache(filename: string) {
        let recentFiles = localStorage.getItem(window.location.origin + window.location.pathname + 'VSWVRecentFiles')

        if (recentFiles !== null) {
            recentFiles = recentFiles.slice(0, -1)
            let fileArr = recentFiles.split(",")
            if (fileArr.indexOf(filename) !== -1) {
                fileArr.splice(fileArr.indexOf(filename), 1)
                fileArr.unshift(filename)
            }
            else {
                if (fileArr.length > 10) {
                    fileArr.pop()
                }
                fileArr.unshift(filename)
            }
            let newRecents = ""
            for (var i = 0; i < fileArr.length; i++) {
                newRecents += fileArr[i] + ","
            }
            localStorage.setItem(window.location.origin + window.location.pathname + 'VSWVRecentFiles', newRecents)
        }
        else {
            localStorage.setItem(window.location.origin + window.location.pathname + 'VSWVRecentFiles', filename + ",")
        }
    }


    OpenFile(filename: string) {
        this.lastFileOpened = filename;
        var width = this.vsCanvas.width
        var height = this.vsCanvas.height

        if (width < 1) {
            width = 1;
        }

        if (height < 1) {
            height = 1;
        }
        let serverEncodingMode = toServerEncoding(this.sessionInfo.canvasMode)

        // image quality
        this.setQuality(this.sessionInfo.compressionLQ, this.sessionInfo.compressionHQ)

        // open file
        var xml = '<Call Method="OpenFile"><FileName>'
        xml += filename
        xml += '</FileName><Width>' + width + '</Width><Height>' + height + '</Height><EncodingState>'
        xml += serverEncodingMode + '</EncodingState></Call>'

        this.command.executeXML(xml)

        this.once("OpenFile", response => {
            if (response.Error === 'SUCCESS') {
                this.serializeFileToCache(filename);
            }
        });

        xml = '<Call Method="AddEventListener">'
        xml += '<Event>ActivateInteraction</Event>'
        xml += '<Event>DeactivateInteraction</Event>'
        xml += '<Event>SelectionChanged</Event>'
        xml += '<Event>SelectionChangedCustomId</Event>'
        xml += '<Event>NodePropertiesChanged</Event></Call>'

        this.command.executeXML(xml)

        this.emit('@OpenedFile', filename);
    }

    ImportFile(filename: string) {
        let xml = '<Call Method="ImportFile"><FileName>' + filename + '</FileName></Call>';
        this.command.executeXML(xml);
    }

    SaveFile(filename: string) {
        var xml = '<Call Method="SaveAs"><FileName>';
        xml += filename;
        xml += '</FileName></Call>';
        this.command.executeXML(xml);
    }

    //View methods
    activateNextConfigurationView() {
        let pos = parseInt(this.activeView.Position);
        if (pos < this.views.length - 1) {
            pos++;
            this.once('ActivateConfigurationView', res => {
                if (res.Error === 'SUCCESS') {
                    this.activeView = this.views[pos];
                    let event: ConfigurationViewChangedEvent = {
                        pos: pos,
                        view: this.activeView
                    };
                    this.emit('ConfigurationViewChanged', event);
                }
            });
            let xml = '<Call Method="ActivateConfigurationView"><Position>' + pos + '</Position></Call>';
            this.command.executeXML(xml);
            return true;
        }
        else {
            return false;
        }
    }

    activatePreviousConfigurationView() {
        let pos = parseInt(this.activeView.Position);
        if (pos > 0) {
            pos--;
            this.once('ActivateConfigurationView', res => {
                if (res.Error === 'SUCCESS') {
                    this.activeView = this.views[pos];
                    let event: ConfigurationViewChangedEvent = {
                        pos: pos,
                        view: this.activeView
                    };
                    this.emit('ConfigurationViewChanged', event);
                }
            });
            let xml = '<Call Method="ActivateConfigurationView"><Position>' + pos + '</Position></Call>';
            this.command.executeXML(xml);
            return true;
        }
        else {
            return false;
        }
    }

    setConfigurationViewPosition(pos: number, withCamera?: boolean, withState?: boolean) {
        if (pos >= 0 && pos < this.views.length) {
            this.once('ActivateConfigurationView', res => {
                if (res.Error === 'SUCCESS') {
                    this.activeView = this.views[pos];
                    let event: ConfigurationViewChangedEvent = {
                        pos: pos,
                        view: this.activeView
                    };
                    this.emit('ConfigurationViewChanged', event);
                }
            });
            let xml = '<Call Method="ActivateConfigurationView"><Position>' + pos + '</Position>'
            if (withCamera !== undefined) {
                xml += '<Camera>' + withCamera + '</Camera>';
            }
            if (withState !== undefined) {
                xml += '<State>' + withState + '</State>'
            };
            xml += '</Call>';
            this.command.executeXML(xml);
            this.selectView(pos);
            return true;
        }
        else {
            return false;
        }
    }

    getConfigurationViewPosition() {
        return this.activeView ? parseInt(this.activeView.Position) : undefined;
    }

    setConfigurationViews(views: ConfigurationViewsData[]) {
        this.views = views;
    }

    getConfigurationViews() {
        return this.views;
    }

    setDefaultConfigurationView(view: ConfigurationViewsData) {
        this.activeView = view;
    }

    selectView(pos: number, addToSelection: boolean = false) {
        if (addToSelection) {
            let index = this.selectedViews.map((v: ConfigurationViewsData) => { return parseInt(v.Position) }).indexOf(pos);
            if (index === -1) {
                this.selectedViews.push(this.views[pos]);
            }
            else {
                this.selectedViews.slice(index, 1);
            }
        }
        else {
            this.selectedViews = [this.views[pos]];
        }
    }

    getSelectedViews() {
        return this.selectedViews;
    }

    checkLicenseInfoFromHash() {
        let userNameString: string = location.hash.split('licenseInfo=').length > 0 ? location.hash.split('licenseInfo=')[1] : undefined;
        let lastReplaceChar: string = userNameString.split('&').length > 1 ? '&' : "";
        userNameString = userNameString.split('&').length > 0 ? userNameString.split('&')[0] : userNameString;
        if (userNameString) {
            this.licenseInfo = decodeURIComponent(escape(window.atob(userNameString)));
            //Flush the license info from the hash
            location.hash = location.hash.replace('licenseInfo=' + userNameString + lastReplaceChar, "");
        }
    }

    relayMessageToBackend(message: string) {
        let relayMessage = '<Request Type="Relay"><Relay>' + message + '</Relay></Request>';
        if (this.sessionInfo && this.sessionInfo.socket) {
            this.sessionInfo.socket.send(relayMessage);
        }
    }

    //Multi sessions
    startSessionSharing() {
        let startMulitSessionCall = '<Request Type="Owner">ShareSession</Request>';
        if (this.sessionInfo && this.sessionInfo.socket) {
            this.isOwnerSession = true;
            this.sessionInfo.socket.send(startMulitSessionCall);
        }
    }

    stopSessionSharing(removeSpectators: boolean = true) {
        let startMulitSessionCall = '<Request Type="Owner">LockSession</Request>';
        if (this.sessionInfo && this.sessionInfo.socket) {
            this.isOwnerSession = false;
            this.ownerBroadCast(JSON.stringify({ RemovedByOwner: true }));
            this.emit('StopSessionSharing');
            this.sessionInfo.socket.send(startMulitSessionCall);
        }
    }

    promoteToController(spectatorId: string) {
        let promotionCall = '<Request Type="Owner"><SetController><ClientId>' + spectatorId + '</ClientId></SetController></Request>';
        if (this.sessionInfo && this.sessionInfo.socket) {
            this.ownerDirectMessage(spectatorId, JSON.stringify({ PromoteToController: true }));
            this.sessionInfo.socket.send(promotionCall);
            this.initOptions.spectatorMode = true;
        }
    }

    takeControlBack(controllerId: string, spectatorSessionId: string) {
        let promotionCall = '<Request Type="Owner"><SetController><ClientId></ClientId></SetController></Request>';
        if (this.sessionInfo && this.sessionInfo.socket) {
            this.ownerDirectMessage(controllerId, JSON.stringify({ DemoteController: true, SpectatorSessionId: spectatorSessionId }));
            this.sessionInfo.socket.send(promotionCall);
            this.initOptions.spectatorMode = false;
        }
    }

    passControlBack() {
        let relayMessage = '<Request Type="Relay"><Relay>' + JSON.stringify({ PassControlBack: true }) + '</Relay></Request>';
        this.controllingSpectator = false;
        if (this.sessionInfo && this.sessionInfo.socket) {
            this.sessionInfo.socket.send(relayMessage);
        }
    }

    removeSpectator(spectatorId: string) {
        let removeCall = '<Request Type="Owner"><RemoveSpectator><ClientId>' + spectatorId + '</ClientId></RemoveSpectator></Request>';
        if (this.sessionInfo && this.sessionInfo.socket) {
            this.ownerDirectMessage(spectatorId, JSON.stringify({ RemovedByOwner: true }));
            this.sessionInfo.socket.send(removeCall);
        }
    }

    ownerDirectMessage(spectatorId: string, message: string) {
        let messageCall = '<Request Type="Owner"><RelayToClient>' + message + '</RelayToClient><ClientId>' + spectatorId + '</ClientId></Request>';
        if (this.sessionInfo && this.sessionInfo.socket) {
            this.sessionInfo.socket.send(messageCall);
        }
    }

    ownerBroadCast(message: string) {
        let broadcastCall = '<Request Type="Owner"><RelayToAll>' + message + '</RelayToAll></Request>';
        if (this.sessionInfo && this.sessionInfo.socket) {
            this.sessionInfo.socket.send(broadcastCall);
        }
    }

    startRect(x: number, y: number) {
        this.rectStarted = true;
        this.vsCanvas.startRect(x, y)
    }

    drawRect(x: number, y: number) {
        if (!this.rectStarted) {
            return;
        }
        if (this.sessionInfo.canvasMode === 'image') {
            this.vsCanvas.drawRectImage(x, y)
        } else if (this.sessionInfo.canvasMode === 'streaming') {
            this.vsCanvas.drawRectStreaming(x, y)
        }
    }

    data(name: string, obj?: any): any {
        if (obj) {
            this[name] = obj
            return obj
        } else {
            return this[name]
        }
    }

    sendBinaryPackage(messageType, payloadType, data) {
        let now = Date.now();
        let eightBytes = convertNumberToBigEndianUInt64(now);
        let binaryPacket = new Uint8Array(2 + 8 + 1 + 1 + data.length); // header + length
        let idx = 0;
        binaryPacket[idx++] = 0;
        binaryPacket[idx++] = 0;
        for (let i = 0; i < 8; i++) {
            binaryPacket[idx++] = eightBytes[i];
        }
        binaryPacket[idx++] = messageType;
        binaryPacket[idx++] = payloadType;
        for (let i = 0; i < data.length; i++) {
            binaryPacket[idx++] = data[i];
        }
        this.sessionInfo.socket.send(binaryPacket.buffer);
    }

    makePing(n) {
        let pingPacket = new Uint8Array(12 + 2 + 4) // header + length
        let idx = 0
        pingPacket[idx++] = 0
        pingPacket[idx++] = 0
        let now = Date.now()
        let eightBytes = convertNumberToBigEndianUInt64(now)
        for (let i = 0; i < 8; i++) {
            pingPacket[idx++] = eightBytes[i]
        }
        pingPacket[idx++] = 1
        pingPacket[idx++] = PAYLOAD_TYPE_BINARY.Ping

        let requestLength = new DataView(pingPacket.buffer, idx, 4)
        requestLength.setUint32(0, n, true)

        this.sessionInfo.socket.send(pingPacket.buffer)
    }

    // makePing(n) {
    // 	console.log('Ping')
    // 	let pingPacket = new Uint8Array(12) // header + length
    // 	let idx = 0
    // 	pingPacket[idx++] = 0
    // 	pingPacket[idx++] = 0
    // 	pingPacket[idx++] = 1
    // 	pingPacket[idx++] = 210

    // 	let requestLength = new DataView(pingPacket.buffer, idx, 4)
    // 	requestLength.setUint32(0, n, true)

    // 	this.sessionInfo.socket.send(pingPacket.buffer)
    // }

    setQuality(low, high) {
        var setQualityCommand = `Quality ${low} ${high}`
        this.command.sendSetQualityCommand(setQualityCommand)

    }


    ///////////////////////////////////////////////////////////////////////////////
    // predefined mouse handlers
    ///////////////////////////////////////////////////////////////////////////////

    mousedownHandler = (ev) => {
        var mouseX = ev.pageX - this.offsetX
        var mouseY = ev.pageY - this.offsetY

        var button = 'None'
        switch (ev.which) {
            case 1:
                button = 'Left'
                if (this.renderSelectionRect) {
                    this.startRect(mouseX, mouseY)
                }
                break
            case 2:
                button = 'Middle'
                break
            case 3:
                button = 'Right'
                break
        }
        var xml = '<Call Method="MouseDown" Response="false"><X>'
            + mouseX + '</X><Y>'
            + mouseY + '</Y>'
            + '<MouseButton>'
            + button + '</MouseButton></Call>'

        this.command.executeXMLMouse(xml)
    }

    touchstartHandler = (ev: TouchEvent) => {
        ev.preventDefault()
        if (ev.touches.length >= 2) {
            return
        }

        let touch: Touch = ev.changedTouches[0]
        var mouseX = touch.pageX - this.offsetX
        var mouseY = touch.pageY - this.offsetY

        var button = 'Left'

        var xml = '<Call Method="MouseDown"><X>'
            + mouseX + '</X><Y>'
            + mouseY + '</Y>'
            + '<MouseButton>'
            + button + '</MouseButton></Call>'

        if (this.renderSelectionRect) {
            this.startRect(mouseX, mouseY)
        }

        this.command.executeXML(xml)

    }

    mousemoveHandler = (ev: MouseEvent) => {
        // prevent the inexplicable mousemove event being triggered in some situation when mouse does not move
        if (ev.pageX === this.lastPagePos.x && ev.pageY === this.lastPagePos.y) {
            return
        }
        this.lastPagePos.x = ev.pageX
        this.lastPagePos.y = ev.pageY

        var mouseX = ev.pageX - this.offsetX
        var mouseY = ev.pageY - this.offsetY
        this.mouseX = mouseX;
        this.mouseY = mouseY;

        var button = 'None'
        switch (ev.which) {
            case 1:
                button = 'Left'
                if (this.renderSelectionRect) {
                    this.drawRect(mouseX, mouseY)
                    return
                }
                break
            case 2:
                button = 'Middle'
                break
            case 3:
                button = 'Right'
                break
        }

        var xml = '<Call Method="MouseMove" Response="true"><X>'
            + mouseX + '</X><Y>'
            + mouseY + '</Y><MouseButton>'
            + button + '</MouseButton></Call>'

        this.command.executeXMLMouseMove(xml)
    }

    touchmoveHandler = (ev: TouchEvent) => {
        ev.preventDefault()

        if (ev.touches.length >= 2) {
            return
        }

        let touch: Touch = ev.changedTouches[0]
        var mouseX = touch.pageX - this.offsetX
        var mouseY = touch.pageY - this.offsetY

        var button = 'Left'

        var xml = '<Call Method="MouseMove" Response="true"><X>'
            + mouseX + '</X><Y>'
            + mouseY + '</Y><MouseButton>'
            + button + '</MouseButton></Call>'

        if (this.renderSelectionRect) {
            this.drawRect(mouseX, mouseY)
        }
        else {
            this.command.executeXMLMouseMove(xml);
        }
    }

    mouseupHandler = (ev) => {
        var mouseX = ev.pageX - this.offsetX
        var mouseY = ev.pageY - this.offsetY
        var button = 'None'
        switch (ev.which) {
            case 1:
                button = 'Left'
                break
            case 2:
                button = 'Middle'
                break
            case 3:
                button = 'Right'
                break
        }

        var mouseFlag = ''
        if (ev.ctrlKey === true) {
            mouseFlag = '<MouseFlag>Ctrl</MouseFlag>'
        }

        var xml = '<Call Method="MouseUp" Response="false"><X>'
            + mouseX + '</X><Y>'
            + mouseY + '</Y>'
            + mouseFlag
            + '<MouseButton>'
            + button + '</MouseButton></Call>'

        this.command.executeXMLMouse(xml)
        this.rectStarted = false;
    }

    touchendHandler = (ev: TouchEvent) => {
        ev.preventDefault()

        if (ev.touches.length >= 2) {
            return
        }

        let touch: Touch = ev.changedTouches[0]
        var mouseX = touch.pageX - this.offsetX
        var mouseY = touch.pageY - this.offsetY

        var button = 'Left'

        var xml = '<Call Method="MouseUp" Response="false"><X>'
            + mouseX + '</X><Y>'
            + mouseY + '</Y>'
            + '<MouseButton>' + button + '</MouseButton></Call>'

        this.command.executeXMLMouse(xml)
        this.rectStarted = false;
    }

    dblclickHandler = (ev) => {
        ev.preventDefault()
        ev.stopPropagation()

        var mouseX = ev.pageX - this.offsetX
        var mouseY = ev.pageY - this.offsetY

        var button = 'None'
        if (ev.which === 1) button = 'Left'

        var xml = '<Call Method="MouseDoubleClick" Response="false"><X>'
            + mouseX + '</X><Y>'
            + mouseY + '</Y><MouseButton>'
            + button + ' </MouseButton></Call>'
        this.command.executeXMLMouse(xml);
    }

    wheelHandler = (ev) => {
        ev.preventDefault()
        var mouseX = ev.pageX - this.offsetX
        var mouseY = ev.pageY - this.offsetY
        var deltaY = ev.deltaY

        // correct delta for firefox
        var correctedDeltaY = navigator.userAgent.indexOf("Firefox") != -1 ? deltaY * -0.1 : deltaY * -0.005

        var xml = '<Call Method="MouseWheel" Response="false"><X>'
            + mouseX + '</X><Y>' + mouseY + '</Y><Delta>'
            + correctedDeltaY + ' </Delta></Call>'

        this.command.executeXMLMouse(xml);
    }

    blockUI() {
        this.vsCanvas.target.appendChild(this.uiBlocker);
    }

    unblockUI() {
        if (this.vsCanvas.target && this.vsCanvas.target.contains(this.uiBlocker)) {
            this.vsCanvas.target.removeChild(this.uiBlocker);
        }
    }
}

///////////////////////////////////////////////////////////////////////////////
// utils
///////////////////////////////////////////////////////////////////////////////

function toServerEncoding(canvasMode: CanvasMode): string {
    let serverEncodingMode: number
    switch (canvasMode) {
        case 'image':
            serverEncodingMode = CODEC_STATUS.JPG
            break
        case 'streaming':
            serverEncodingMode = CODEC_STATUS.H264
            break
    }

    return CODEC_STATUS.toString(serverEncodingMode)
}

interface Offset {
    x: number;
    y: number;
}

function findTheOffset(el: HTMLElement): Offset {
    let parent = el
    let xPosition = 0
    let yPosition = 0
    while (parent) {
        xPosition += (parent.offsetLeft - parent.scrollLeft + parent.clientLeft)
        yPosition += (parent.offsetTop - parent.scrollTop + parent.clientTop)
        parent = <HTMLElement>parent.offsetParent
    }

    return {
        x: xPosition,
        y: yPosition
    }
}

// Encode an ArrayBuffer as a base64 string directly
// reference: https://gist.github.com/jonleighton/958841

function base64ArrayBuffer(arrayBuffer, offset, length) {
    var base64 = ''
    var encodings = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'

    var bytes = new Uint8Array(arrayBuffer, offset, length)
    var byteLength = bytes.byteLength
    var byteRemainder = byteLength % 3
    var mainLength = byteLength - byteRemainder

    var a, b, c, d
    var chunk

    // Main loop deals with bytes in chunks of 3
    for (var i = 0; i < mainLength; i = i + 3) {
        // Combine the three bytes into a single integer
        chunk = (bytes[i] << 16) | (bytes[i + 1] << 8) | bytes[i + 2]

        // Use bitmasks to extract 6-bit segments from the triplet
        a = (chunk & 16515072) >> 18 // 16515072 = (2^6 - 1) << 18
        b = (chunk & 258048) >> 12 // 258048   = (2^6 - 1) << 12
        c = (chunk & 4032) >> 6 // 4032     = (2^6 - 1) << 6
        d = chunk & 63               // 63       = 2^6 - 1

        // Convert the raw binary segments to the appropriate ASCII encoding
        base64 += encodings[a] + encodings[b] + encodings[c] + encodings[d]
    }

    // Deal with the remaining bytes and padding
    if (byteRemainder == 1) {
        chunk = bytes[mainLength]

        a = (chunk & 252) >> 2 // 252 = (2^6 - 1) << 2

        // Set the 4 least significant bits to zero
        b = (chunk & 3) << 4 // 3   = 2^2 - 1

        base64 += encodings[a] + encodings[b] + '=='
    } else if (byteRemainder == 2) {
        chunk = (bytes[mainLength] << 8) | bytes[mainLength + 1]

        a = (chunk & 64512) >> 10 // 64512 = (2^6 - 1) << 10
        b = (chunk & 1008) >> 4 // 1008  = (2^6 - 1) << 4

        // Set the 2 least significant bits to zero
        c = (chunk & 15) << 2 // 15    = 2^4 - 1

        base64 += encodings[a] + encodings[b] + encodings[c] + '='
    }

    return base64
}



// WEBPACK FOOTER //
// ./base/vsweb-client-impl.ts